export const GOOGLE_MAPS_API_KEY = "AIzaSyBU2qHqCdwW-Fl-Xjow0MP05mDECcDQlow";
